export const availableExaktaTShirtSKUs = [
    /*
    "TS-GIL-64000B-BLACK-XS",
    "TS-GIL-64000B-BLACK-S",
    "TS-GIL-64000B-BLACK-M",
    "TS-GIL-64000B-BLACK-L",
    "TS-GIL-64000B-BLACK-XL",

    "TS-GIL-64000B-MILITARY-GREEN-XS",
    "TS-GIL-64000B-MILITARY-GREEN-S",
    "TS-GIL-64000B-MILITARY-GREEN-M",
    "TS-GIL-64000B-MILITARY-GREEN-L",
    "TS-GIL-64000B-MILITARY-GREEN-XL",

    "TS-GIL-64000B-RED-XS",
    "TS-GIL-64000B-RED-S",
    "TS-GIL-64000B-RED-M",
    "TS-GIL-64000B-RED-L",
    "TS-GIL-64000B-RED-XL",

    "TS-GIL-64000B-WHITE-XS",
    "TS-GIL-64000B-WHITE-S",
    "TS-GIL-64000B-WHITE-M",
    "TS-GIL-64000B-WHITE-L",
    "TS-GIL-64000B-WHITE-XL",

    "TS-GIL-64000L-BLACK-S",
    "TS-GIL-64000L-BLACK-M",
    "TS-GIL-64000L-BLACK-L",
    "TS-GIL-64000L-BLACK-XL",

    "TS-GIL-64000L-WHITE-S",
    "TS-GIL-64000L-WHITE-M",
    "TS-GIL-64000L-WHITE-L",
    "TS-GIL-64000L-WHITE-XL",

    "TS-GIL-64000-BLACK-S",
    "TS-GIL-64000-BLACK-M",
    "TS-GIL-64000-BLACK-L",
    "TS-GIL-64000-BLACK-XL",
    "TS-GIL-64000-BLACK-2XL",
    "TS-GIL-64000-BLACK-3XL",

    "TS-GIL-64000-MILITARY-GREEN-S",
    "TS-GIL-64000-MILITARY-GREEN-M",
    "TS-GIL-64000-MILITARY-GREEN-L",
    "TS-GIL-64000-MILITARY-GREEN-XL",
    "TS-GIL-64000-MILITARY-GREEN-2XL",

    "TS-GIL-64000-NAVY-S",
    "TS-GIL-64000-NAVY-M",
    "TS-GIL-64000-NAVY-L",
    "TS-GIL-64000-NAVY-XL",
    "TS-GIL-64000-NAVY-2XL",

    "TS-GIL-64000-RED-2XL",
    "TS-GIL-64000-RED-S",
    "TS-GIL-64000-RED-M",
    "TS-GIL-64000-RED-L",
    "TS-GIL-64000-RED-XL",

    "TS-GIL-64000-RS-SPORT-GREY-S",
    "TS-GIL-64000-RS-SPORT-GREY-M",
    "TS-GIL-64000-RS-SPORT-GREY-L",
    "TS-GIL-64000-RS-SPORT-GREY-XL",
    "TS-GIL-64000-RS-SPORT-GREY-2XL",

    "TS-GIL-64000-LIGHT-BLUE-S",
    "TS-GIL-64000-LIGHT-BLUE-M",
    "TS-GIL-64000-LIGHT-BLUE-L",
    "TS-GIL-64000-LIGHT-BLUE-XL",
    "TS-GIL-64000-LIGHT-BLUE-2XL",

    "TS-GIL-64000-WHITE-S",
    "TS-GIL-64000-WHITE-M",
    "TS-GIL-64000-WHITE-L",
    "TS-GIL-64000-WHITE-XL",
    "TS-GIL-64000-WHITE-2XL",
    "TS-GIL-64000-WHITE-3XL",


    'TS-GIL-64000-MILITARY-GREEN-XL',
    'TS-GIL-64000-MILITARY-GREEN-S',
    'TS-GIL-64000-MILITARY-GREEN-M',
    'TS-GIL-64000-MILITARY-GREEN-L',
    'TS-GIL-64000-MILITARY-GREEN-2XL',

    'STD_DTG_T-SHIRT_F'
*/
];


export const availableExaktaHoodieSKUs = [
    /*
    'H-GIL-18500B-BLACK-XS',
    'H-GIL-18500B-BLACK-S',
    'H-GIL-18500B-BLACK-M',
    'H-GIL-18500B-BLACK-L',
    'H-GIL-18500B-BLACK-XL',
    'H-GIL-18500-WHITE-S',
    'H-GIL-18500-WHITE-M',
    'H-GIL-18500-WHITE-L',
    'H-GIL-18500-WHITE-XL',
    'H-GIL-18500-BLACK-S',
    'H-GIL-18500-BLACK-M',
    'H-GIL-18500-BLACK-L',
    'H-GIL-18500-BLACK-XL',
    'H-GIL-18500-BLACK-2XL',
    'H-GIL-18500-BLACK-3XL',
    'H-GIL-18500-NAVY-S',
    'H-GIL-18500-NAVY-M',
    'H-GIL-18500-NAVY-L',
    'H-GIL-18500-NAVY-XL',
    'H-GIL-18500-SPORT-GREY-S',
    'H-GIL-18500-SPORT-GREY-M',
    'H-GIL-18500-SPORT-GREY-L',
    'H-GIL-18500-SPORT-GREY-XL',
    'H-JH-JH001-ARCTIC-WHITE-XS',
    'H-JH-JH001-ARCTIC-WHITE-S',
    'H-JH-JH001-ARCTIC-WHITE-M',
    'H-JH-JH001-ARCTIC-WHITE-L',
    'H-JH-JH001-ARCTIC-WHITE-XL',
    'H-JH-JH001-ARCTIC-WHITE-XXL',
    'H-JH-JH001-ARCTIC-WHITE-3XL',
    'H-JH-JH001-DEEP-BLACK-XS',
    'H-JH-JH001-DEEP-BLACK-S',
    'H-JH-JH001-DEEP-BLACK-M',
    'H-JH-JH001-DEEP-BLACK-L',
    'H-JH-JH001-DEEP-BLACK-XL',
    'H-JH-JH001-DEEP-BLACK-XXL',
    'H-JH-JH001-DEEP-BLACK-3XL',
    'H-JH-JH001-HEATHER-GREY-XS',
    'H-JH-JH001-HEATHER-GREY-S',
    'H-JH-JH001-HEATHER-GREY-M',
    'H-JH-JH001-HEATHER-GREY-L',
    'H-JH-JH001-HEATHER-GREY-XL',
    'H-JH-JH001-HEATHER-GREY-XXL',
    'H-JH-JH001-HEATHER-GREY-3XL',
    'H-STA-STSU822-BLACK-S',
    'H-STA-STSU822-BLACK-M',
    'H-STA-STSU822-BLACK-L',
    'H-STA-STSU822-BLACK-XL',
    'H-STA-STSU822-BLACK-2XL'
    */
];

export const availableExaktaMerchSKUs = [
    'STD_MUG_11'
];

export const availableExaktaOtherSKUs = [
    'STD_STUDENT_50x70',

    /*
    'SWS-GIL-18000-WHITE-S',
    'SWS-GIL-18000-WHITE-M',
    'SWS-GIL-18000-WHITE-L',
    'SWS-GIL-18000-WHITE-XL',
    'SWS-GIL-18000-BLACK-S',
    'SWS-GIL-18000-BLACK-M',
    'SWS-GIL-18000-BLACK-L',
    'SWS-GIL-18000-BLACK-XL',
    'SWS-JH-JH030-JET-BLACK-S',
    'SWS-JH-JH030-JET-BLACK-M',
    'SWS-JH-JH030-JET-BLACK-L',
    'SWS-JH-JH030-JET-BLACK-XL',
    'SWS-JH-JH030-OXFORD-NAVY-S',
    'SWS-JH-JH030-OXFORD-NAVY-M',
    'SWS-JH-JH030-OXFORD-NAVY-L',
    'SWS-JH-JH030-OXFORD-NAVY-XL',
    'SWS-STA-STSU823-BLACK-S',
    'SWS-STA-STSU823-BLACK-M',
    'SWS-STA-STSU823-BLACK-L',
    'SWS-STA-STSU823-BLACK-XL',
    'SWS-STA-STSU823-BLACK-2XL',
    'TB-WM-W101-WHITE-ONESIZE',
    'TB-WM-W101-BLACK-ONESIZE',
    'TB-WM-W101-NATURAL-ONESIZE',
    'TB-WM-W801-BLACK-ONESIZE',
    'TB-WM-W801-NATURAL-ONESIZE'
    */
]

export const availableExaktaSignSKUs = [

]

export const availableExaktaStockItemSKUs = [
    'HOOK',

    'FRAME_21x30_BLACK',
    'FRAME_30x40_BLACK',
    'FRAME_40x50_BLACK',
    'FRAME_50x50_BLACK',
    'FRAME_50x70_BLACK',
    'FRAME_70x100_BLACK',
    'FRAME_100x140_BLACK',

    'FRAME_21x30_WHITE',
    'FRAME_30x40_WHITE',
    'FRAME_40x50_WHITE',
    'FRAME_50x50_WHITE',
    'FRAME_50x70_WHITE',
    'FRAME_70x100_WHITE',
    'FRAME_100x140_WHITE',

    'FRAME_21x30_OAK',
    'FRAME_30x40_OAK',
    'FRAME_40x50_OAK',
    'FRAME_50x50_OAK',
    'FRAME_50x70_OAK',
    'FRAME_70x100_OAK',
    'FRAME_100x140_OAK',


    'FRAME_21x30_WALNUT',
    'FRAME_30x40_WALNUT',
    'FRAME_40x50_WALNUT',
    'FRAME_50x50_WALNUT',
    'FRAME_50x70_WALNUT',
    'FRAME_70x100_WALNUT',
    'FRAME_100x140_WALNUT',

    'FRAME_21x30_M_BLACK',
    'FRAME_30x40_M_BLACK',
    //'FRAME_40x50_M_BLACK',
    //'FRAME_50x50_M_BLACK',
    'FRAME_50x70_M_BLACK',
    'FRAME_70x100_M_BLACK',
    'FRAME_100x140_M_BLACK',

    'FRAME_21x30_M_GOLD',
    'FRAME_30x40_M_GOLD',
    //'FRAME_40x50_M_GOLD',
    //'FRAME_50x50_M_GOLD',
    'FRAME_50x70_M_GOLD',
    'FRAME_70x100_M_GOLD',
    'FRAME_100x140_M_GOLD',

    'FRAME_21x30_M_SILVER',
    'FRAME_30x40_M_SILVER',
    //'FRAME_40x50_M_SILVER',
    //'FRAME_50x50_M_SILVER',
    'FRAME_50x70_M_SILVER',
    'FRAME_70x100_M_SILVER',
    'FRAME_100x140_M_SILVER',

    'FRAME_21x30_M_COPPER',
    'FRAME_30x40_M_COPPER',
    'FRAME_50x70_M_COPPER',
    'FRAME_70x100_M_COPPER',
    'FRAME_100x140_M_COPPER',

    'FRAME_21x30_BLUE',
    'FRAME_30x40_BLUE',
    'FRAME_50x70_BLUE',
    'FRAME_70x100_BLUE',
    'FRAME_100x140_BLUE',
    'FRAME_21x30_GREEN',
    'FRAME_30x40_GREEN',
    'FRAME_50x70_GREEN',
    'FRAME_70x100_GREEN',
    'FRAME_100x140_GREEN',
    'FRAME_21x30_RED',
    'FRAME_30x40_RED',
    'FRAME_50x70_RED',
    'FRAME_70x100_RED',
    'FRAME_100x140_RED',
    'FRAME_21x30_YELLOW',
    'FRAME_30x40_YELLOW',
    'FRAME_50x70_YELLOW',
    'FRAME_70x100_YELLOW',
    'FRAME_100x140_YELLOW',

    'PASSEPARTOUT_WHITE_21x30',
    'PASSEPARTOUT_WHITE_30x40',
    'PASSEPARTOUT_WHITE_50x70',
    'PASSEPARTOUT_WHITE_70x100',

    'POSTER_HANGER_30_BLACK',
    'POSTER_HANGER_30_OAK',
    'POSTER_HANGER_30_WHITE',
    'POSTER_HANGER_50_BLACK',
    'POSTER_HANGER_50_OAK',
    'POSTER_HANGER_50_WHITE',
    'POSTER_HANGER_70_BLACK',
    'POSTER_HANGER_70_OAK',
    'POSTER_HANGER_70_WHITE',


    'CANVASFRAME_30x40_BLACK',
    'CANVASFRAME_30x40_WHITE',
    'CANVASFRAME_40x60_BLACK',
    'CANVASFRAME_40x60_WHITE',
    'CANVASFRAME_50x70_BLACK',
    'CANVASFRAME_50x70_WHITE',
    'CANVASFRAME_70x100_BLACK',
    'CANVASFRAME_70x100_WHITE',
    'CANVASFRAME_80x120_BLACK',
    'CANVASFRAME_80x120_WHITE',
    'CANVASFRAME_30x40_OAK',
    'CANVASFRAME_40x60_OAK',
    'CANVASFRAME_50x70_OAK',
    'CANVASFRAME_70x100_OAK',
    'CANVASFRAME_80x120_OAK',

];

export const availableExaktaPosterSKUs = [
    'Poster_13x18_obestruket',
    'Poster_18x13_obestruket',
    'Poster_21x30_obestruket',
    'Poster_30x21_obestruket',
    'Poster_30x30_obestruket',
    'Poster_30x40_obestruket',
    'Poster_40x30_obestruket',
    'Poster_40x50_obestruket',
    'Poster_50x40_obestruket',
    'Poster_50x50_obestruket',
    'Poster_50x70_obestruket',
    'Poster_70x70_obestruket',
    'Poster_70x50_obestruket',
    'Poster_70x100_obestruket',
    'Poster_100x70_obestruket',
    'Poster_100x140_obestruket',
    'Poster_140x100_obestruket',
    //    'Poster_80x120_obestruket',
    //    'Poster_120x80_obestruket',

    'Poster_13x18_bestruket',
    'Poster_18x13_bestruket',
    'Poster_21x30_bestruket',
    'Poster_30x21_bestruket',
    'Poster_30x30_bestruket',
    'Poster_30x40_bestruket',
    'Poster_40x30_bestruket',
    'Poster_40x50_bestruket',
    'Poster_50x50_bestruket',
    'Poster_50x70_bestruket',
    'Poster_70x50_bestruket',
    'Poster_70x100_bestruket',
    'Poster_100x70_bestruket',
    'Poster_100x140_bestruket',
    'Poster_140x100_bestruket',
    //    'Poster_120x80_bestruket',
    //    'Poster_80x120_bestruket',
];

export const availableExaktaCanvasSKUs = [
    'Canvas_20x30',
    'Canvas_30x20',

    'Canvas_30x40',
    'Canvas_40x30',

    'Canvas_40x50',
    'Canvas_50x50',

    'Canvas_40x60',
    'Canvas_60x40',

    'Canvas_80x60',
    'Canvas_60x80',

    'Canvas_50x50',

    'Canvas_50x70',
    'Canvas_70x50',

    'Canvas_50x75',
    'Canvas_75x50',

    'Canvas_70x100',
    'Canvas_100x70',

    'Canvas_80x120',
    'Canvas_120x80',

    'Canvas_100x150'
];

export const availableExaktaSKUs = [
    'Wallpaper',
].concat(availableExaktaStockItemSKUs,
    availableExaktaTShirtSKUs,
    availableExaktaHoodieSKUs,
    availableExaktaOtherSKUs,
    availableExaktaMerchSKUs,
    availableExaktaPosterSKUs,
    availableExaktaCanvasSKUs,
);

